import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { safeLocalStorage } from "@/utils/safeStorage";
import { joinToOrganization } from "api/organizations";
import { OrganizationException } from "js/exceptions/OrganizationException";

interface JoinToOrganizationState {
  error: null | boolean;
  success: null | boolean;
  joinMessage?: string;
}

const initialState: JoinToOrganizationState = {
  error: null,
  success: null,
};

export const useJoinOrganization = () => {
  const { userToken } = useAppSelector((state) => state.entities.auth);

  const [state, setState] = useState<JoinToOrganizationState>(initialState);

  useEffect(() => {
    onOrganizationJoin();
  }, []);

  const onOrganizationJoin = (): void => {
    // MB-APP-EXPRESS-151/-182: mismo patron sin guarda que en
    // useDecodeInviteToken, pero en el efecto que monta el Dashboard. Sin esto
    // el arreglo de /login solo MOVERIA el crash a "/".
    const inviteTokenStorage: string | null =
      safeLocalStorage.getItem("invite_token");

    if (!!userToken && !!inviteTokenStorage) {
      joinToOrganization(inviteTokenStorage)
        .then(() => setState({ ...state, error: null, success: true }))
        .catch((err) => {
          // Un fallo de red deja `err.response` en undefined: sin el
          // encadenamiento opcional esto lanza un TypeError dentro del
          // `.catch` -> rechazo no manejado -> issue NUEVO de Sentry en un
          // camino que este arreglo vuelve alcanzable por primera vez.
          const errorCode = err?.response?.data?.code;
          const organizationException = new OrganizationException(errorCode);
          const errorMessage = organizationException.message;
          setState({
            ...state,
            error: true,
            success: false,
            joinMessage: errorMessage,
          });
        })
        .finally(() => safeLocalStorage.removeItem("invite_token"));
    }
  };

  return state;
};
